var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaBesorgungen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d1d4d1;}.cls-3{fill:#556080;}.cls-4{fill:#212654;}.cls-5{fill:#76b72a;}.cls-6{fill:#309eed;}.cls-7{fill:#ea5c0b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.34,
    y: 51.45,
    width: 119.18,
    height: 59.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152,113.52H27.86V49H152Zm-119.17-5H147V53.92H32.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.34,31.58H17.93a2.48,2.48,0,1,1,0-5H30.34a2.48,2.48,0,1,1,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.34,53.92a2.47,2.47,0,0,1-2.48-2.47V29.09a2.49,2.49,0,0,1,5,0V51.45a2.48,2.48,0,0,1-2.49,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.34,130.89a2.47,2.47,0,0,1-2.48-2.48V111a2.49,2.49,0,1,1,5,0v17.37a2.48,2.48,0,0,1-2.49,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.1,140.82a9.93,9.93,0,1,1-9.93-9.93,9.93,9.93,0,0,1,9.93,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.7,140.82a9.94,9.94,0,1,1-9.94-9.93,9.94,9.94,0,0,1,9.94,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.12,130.89H30.34a2.48,2.48,0,1,1,0-4.95H137.12a2.48,2.48,0,0,1,0,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.53,73.79H30.34a2.49,2.49,0,0,1,0-5H149.53a2.49,2.49,0,0,1,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.53,93.65H30.34a2.48,2.48,0,1,1,0-5H149.53a2.48,2.48,0,0,1,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.21,113.52A2.49,2.49,0,0,1,47.73,111V51.45a2.48,2.48,0,1,1,5,0V111a2.49,2.49,0,0,1-2.48,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.07,113.52A2.49,2.49,0,0,1,67.59,111V51.45a2.49,2.49,0,1,1,5,0V111a2.49,2.49,0,0,1-2.49,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.93,113.52A2.48,2.48,0,0,1,87.46,111V51.45a2.48,2.48,0,1,1,5,0V111a2.49,2.49,0,0,1-2.48,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.8,113.52a2.49,2.49,0,0,1-2.49-2.48V51.45a2.49,2.49,0,0,1,5,0V111a2.49,2.49,0,0,1-2.49,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.66,113.52a2.49,2.49,0,0,1-2.49-2.48V51.45a2.49,2.49,0,1,1,5,0V111a2.49,2.49,0,0,1-2.48,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.9,29.09a7.45,7.45,0,1,1-7.46-7.44,7.45,7.45,0,0,1,7.46,7.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 42.76,
    y: 29.09,
    width: 34.76,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 77.51,
    y: 9.24,
    width: 39.73,
    height: 39.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.24,
    y: 16.68,
    width: 24.83,
    height: 32.28
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaBesorgungen);
export default __webpack_public_path__ + "static/media/ka_besorgungen.6d7719a26486528021b21a4ace95ecba.svg";
export { ForwardRef as ReactComponent };